import React from "react";

const LoyaltyMemberInfo = ({ user }) => {
  console.log("lklk", user);
  return (
    <div className="member-card">
      <div className="member-header">
       <div className="member-avatar">
  <span>
    {user?.name?.slice(0, 2).toUpperCase()}
  </span>
</div>
        <div className="member-info">
          <h3>{user.name}</h3>
          <p>
            Member since {" "}
            {new Date(user.accountCreatedDate).toLocaleDateString("en-US", {
              month: "short",
              day: "2-digit",
              year: "numeric",
            })}
          </p>
        </div>
      </div>
      <div className="divider"></div>
      <div className="contact-info">
        <div className="contact-item">
          <div className="contact-icon">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <rect width="20" height="16" x="2" y="4" rx="2" />
              <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
            </svg>
          </div>
          <span>{user.email}</span>
        </div>
        <div className="contact-item">
          <div className="contact-icon">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
            </svg>
          </div>
          <span>{user.phoneNumber}</span>
        </div>
      </div>
    </div>
  );
};

export default LoyaltyMemberInfo;
